import { APP_USER_DETAILS_LIST } from 'actions/dataReport';

const initialState = {
  isLoading: false,
  appUserDetailsLists: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const appUserDetailsListReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case APP_USER_DETAILS_LIST.REQUEST: {
      return { ...state, isLoading: true };
    }
    case APP_USER_DETAILS_LIST.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        appUserDetailsLists: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }

    case APP_USER_DETAILS_LIST.FAIL: {
      return { ...state, isLoading: false };
    }
    default:
      return { ...state };
  }
};
export default appUserDetailsListReducer;
